import { render, staticRenderFns } from "./ArchiveRequests.vue?vue&type=template&id=bc741cc2&"
import script from "./ArchiveRequests.vue?vue&type=script&lang=js&"
export * from "./ArchiveRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports